import { StreetLines } from './route-types';

export const demoStreetLines: StreetLines = [
  {
    streetName: 'Bus 8',
    routeId: '8',
    stops: [
      {
        streetName: 'Bus 8',
        stopCode: 'A1',
        stopName: 'Zhong Sheng Avenue A',
        stopLat: 39.1231724303889,
        stopLon: 117.74237544047,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 8',
        stopCode: 'A2',
        stopName: 'Hilton Hotels A',
        stopLat: 39.1255255122242,
        stopLon: 117.740201680603,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 8',
        stopCode: 'A3',
        stopName: 'Jinxiang Wildlife Park A',
        stopLat: 39.1424684644155,
        stopLon: 117.728611973598,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 8',
        stopCode: 'A4',
        stopName: 'Fantawild Adventure A',
        stopLat: 39.1510654587967,
        stopLon: 117.728663273303,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 8',
        stopCode: 'A5',
        stopName: 'Boonie Bears Hotel A',
        stopLat: 39.1574168970884,
        stopLon: 117.732741412815,

        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 8',
        stopCode: 'A6',
        stopName: 'Boonie Bears Hotel B',
        stopLat: 39.1574764240606,
        stopLon: 117.732511986464,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 8',
        stopCode: 'A7',
        stopName: 'Fantawild Adventure B',
        stopLat: 39.1509651689732,
        stopLon: 117.728410644508,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 8',
        stopCode: 'A8',
        stopName: 'Jinxiang Wildlife Park B',
        stopLat: 39.1426302987789,
        stopLon: 117.728346050631,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 8',
        stopCode: 'A9',
        stopName: 'Hilton Hotels B',
        stopLat: 39.1254564765744,
        stopLon: 117.739735040094,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 8',
        stopCode: 'A10',
        stopName: 'Zhong Sheng Avenue B',
        stopLat: 39.1231146037986,
        stopLon: 117.742132500358,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
    ],
  },
  {
    streetName: 'Bus 11',
    routeId: '11',
    stops: [
      {
        streetName: 'Bus 11',
        stopCode: 'B1',
        stopName: 'Hilton Hotels B',
        stopLat: 39.1254564765744,
        stopLon: 117.739735040094,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 11',
        stopCode: 'B2',
        stopName: 'Ecological Valley Greenway Park B',
        stopLat: 39.1191841788599,
        stopLon: 117.745913453314,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 11',
        stopCode: 'B3',
        stopName: 'Binlv Industrial Park B',
        stopLat: 39.1058914765497,
        stopLon: 117.750232799226,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 11',
        stopCode: 'B4',
        stopName: 'Aegean Sea Shopping Park B',
        stopLat: 39.0982426900992,
        stopLon: 117.761467504927,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 11',
        stopCode: 'B5',
        stopName: 'Ecological Valley Greenway Park B',
        stopLat: 39.1071222751003,
        stopLon: 117.786878038746,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 11',
        stopCode: 'B6',
        stopName: 'National Maritime Museum A',
        stopLat: 39.1070626028351,
        stopLon: 117.786714010154,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 11',
        stopCode: 'B7',
        stopName: 'Aegean Sea Shopping Park A',
        stopLat: 39.0979048903213,
        stopLon: 117.76107878387,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 11',
        stopCode: 'B8',
        stopName: 'Binlv Industrial Park A',
        stopLat: 39.1049937572922,
        stopLon: 117.749575010028,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 11',
        stopCode: 'B9',
        stopName: 'Ecological Valley Greenway Park A',
        stopLat: 39.119408899806,
        stopLon: 117.745994460311,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'Bus 11',
        stopCode: 'B10',
        stopName: 'Hilton Hotels A',
        stopLat: 39.1255255122242,
        stopLon: 117.740201680603,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
    ],
  },
  {
    streetName: 'All Stops',
    routeId: '999',
    stops: [
      {
        streetName: 'All Stops',
        stopCode: 'A1',
        stopName: 'Zhong Sheng Avenue A',
        stopLat: 39.1231724303889,
        stopLon: 117.74237544047,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'A2',
        stopName: 'Hilton Hotels A',
        stopLat: 39.1255255122242,
        stopLon: 117.740201680603,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'A3',
        stopName: 'Jinxiang Wildlife Park A',
        stopLat: 39.1424684644155,
        stopLon: 117.728611973598,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'A4',
        stopName: 'Fantawild Adventure A',
        stopLat: 39.1510654587967,
        stopLon: 117.728663273303,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'A5',
        stopName: 'Boonie Bears Hotel A',
        stopLat: 39.1574168970884,
        stopLon: 117.732741412815,

        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'A6',
        stopName: 'Boonie Bears Hotel B',
        stopLat: 39.1574764240606,
        stopLon: 117.732511986464,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'A7',
        stopName: 'Fantawild Adventure B',
        stopLat: 39.1509651689732,
        stopLon: 117.728410644508,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'A8',
        stopName: 'Jinxiang Wildlife Park B',
        stopLat: 39.1426302987789,
        stopLon: 117.728346050631,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'A9',
        stopName: 'Hilton Hotels B',
        stopLat: 39.1254564765744,
        stopLon: 117.739735040094,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'A10',
        stopName: 'Zhong Sheng Avenue B',
        stopLat: 39.1231146037986,
        stopLon: 117.742132500358,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'B1',
        stopName: 'Hilton Hotels B',
        stopLat: 39.1254564765744,
        stopLon: 117.739735040094,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'B2',
        stopName: 'Ecological Valley Greenway Park B',
        stopLat: 39.1191841788599,
        stopLon: 117.745913453314,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'B3',
        stopName: 'Binlv Industrial Park B',
        stopLat: 39.1058914765497,
        stopLon: 117.750232799226,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'B4',
        stopName: 'Aegean Sea Shopping Park B',
        stopLat: 39.0982426900992,
        stopLon: 117.761467504927,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'B5',
        stopName: 'Ecological Valley Greenway Park B',
        stopLat: 39.1071222751003,
        stopLon: 117.786878038746,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'B6',
        stopName: 'National Maritime Museum A',
        stopLat: 39.1070626028351,
        stopLon: 117.786714010154,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'B7',
        stopName: 'Aegean Sea Shopping Park A',
        stopLat: 39.0979048903213,
        stopLon: 117.76107878387,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'B8',
        stopName: 'Binlv Industrial Park A',
        stopLat: 39.1049937572922,
        stopLon: 117.749575010028,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'B9',
        stopName: 'Ecological Valley Greenway Park A',
        stopLat: 39.119408899806,
        stopLon: 117.745994460311,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
      {
        streetName: 'All Stops',
        stopCode: 'B10',
        stopName: 'Hilton Hotels A',
        stopLat: 39.1255255122242,
        stopLon: 117.740201680603,
        mrtStationCode: '',
        mrtStationName: '',
        busTerminal: false,
      },
    ],
  },
];
